// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.dialog-container {
  width: 340px;
  height: 250px;
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  padding: 15px !important;
}

.dialog-header {
  padding-top: 20px !important;
  padding-bottom: 15px !important;
  text-align: center;
}

.dialog-header h2 {
  margin: 0;
  color: #ff6b00;
  font-size: 20px;
  font-weight: normal;
  padding: 15px 15px !important;
}

.dialog-content {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px !important;
}

.dialog-content p {
  margin: 0;
  text-align: center;
  font-size: 16px;
}

.dialog-footer {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
  display: flex;
  justify-content: center;
  gap: 15px !important;
}

/* 공통 버튼 스타일 */
.dialog-footer button {
  border: none;
  border-radius: 5px;
  padding: 10px 20px !important;
  cursor: pointer;
  font-size: 16px;
  height: 50px;
  margin: 15px !important;
}

/* 취소 버튼 스타일 (예: 아니오) */
.dialog-refund-no-button {
  background-color: #FF6F0F;
  color: white;
  width: 150px;
}

/* 확인 버튼 스타일 (예: 예) */
.dialog-refund-yes-button {
  background-color: #ccc;
  color: white;
  width: 100px;
}

/* 단일 확인 버튼 스타일 */
.dialog-refund-confirm-button {
  background-color: #FF6F0F;
  color: white;
  width: 270px;
}

/* 레거시 스타일 유지 (이전 코드와의 호환성을 위해) */
.edit-success-button,
.reset-success-button,
.default-confirm-button {
  background-color: #ff6b00;
  color: white;
  border: none;
  border-radius: 4px;
  width: 270px;
  height: 50px;
  font-size: 16px;
  cursor: pointer;
} `, "",{"version":3,"sources":["webpack://./src/styles/Dialog.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,cAAc;AACd;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA,iCAAiC;AACjC;;;EAGE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB","sourcesContent":[".dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.dialog-container {\n  width: 340px;\n  height: 250px;\n  background-color: white;\n  border-radius: 10px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  padding: 15px !important;\n}\n\n.dialog-header {\n  padding-top: 20px !important;\n  padding-bottom: 15px !important;\n  text-align: center;\n}\n\n.dialog-header h2 {\n  margin: 0;\n  color: #ff6b00;\n  font-size: 20px;\n  font-weight: normal;\n  padding: 15px 15px !important;\n}\n\n.dialog-content {\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 15px !important;\n}\n\n.dialog-content p {\n  margin: 0;\n  text-align: center;\n  font-size: 16px;\n}\n\n.dialog-footer {\n  padding-top: 20px !important;\n  padding-bottom: 20px !important;\n  display: flex;\n  justify-content: center;\n  gap: 15px !important;\n}\n\n/* 공통 버튼 스타일 */\n.dialog-footer button {\n  border: none;\n  border-radius: 5px;\n  padding: 10px 20px !important;\n  cursor: pointer;\n  font-size: 16px;\n  height: 50px;\n  margin: 15px !important;\n}\n\n/* 취소 버튼 스타일 (예: 아니오) */\n.dialog-refund-no-button {\n  background-color: #FF6F0F;\n  color: white;\n  width: 150px;\n}\n\n/* 확인 버튼 스타일 (예: 예) */\n.dialog-refund-yes-button {\n  background-color: #ccc;\n  color: white;\n  width: 100px;\n}\n\n/* 단일 확인 버튼 스타일 */\n.dialog-refund-confirm-button {\n  background-color: #FF6F0F;\n  color: white;\n  width: 270px;\n}\n\n/* 레거시 스타일 유지 (이전 코드와의 호환성을 위해) */\n.edit-success-button,\n.reset-success-button,\n.default-confirm-button {\n  background-color: #ff6b00;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  width: 270px;\n  height: 50px;\n  font-size: 16px;\n  cursor: pointer;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
